import { css } from 'styled-components';

import { styledReset } from './reset';

export const allianceFontStack =
    "'Alliance No.1', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";

export const tuskerFontStack = "'Tusker Grotesk', Helvetica, Arial, sans-serif";

export const allianceBase = css`
    ${styledReset.typography};
    font-family: ${allianceFontStack};
    font-size: 16px;
    color: white;
`;

export const tuskerBase = css`
    ${styledReset.typography};
    font-family: ${tuskerFontStack};
    font-size: 16px;
    color: white;
`;

function breakLongLines(anywhere = false) {
    const wrap = anywhere ? 'anywhere' : 'break-word';

    return css`
        overflow-wrap: ${wrap};
        hyphens: auto;
    `;
}

const breakTextarea = css`
    white-space: pre-wrap;
    // There might be a difference in browser behaviour,
    // so we should verify if 'break-word' is ever used.
    // overflow-wrap: break-word;
    overflow-wrap: anywhere;
`;

function lineClamp(max = 2) {
    return css`
        @supports (-webkit-line-clamp: ${max}) {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: ${max};
            overflow: hidden;
        }
    `;
}

const textBoxTrim = css`
    &::before {
        content: '';
        display: block;
        height: 0;
        width: 0;
        margin-top: -0.14em;
    }
`;

const truncate = css`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

const truncateOffsetY = 0.14;

function truncateHeightFix(nudge = false) {
    const marginBottom = nudge ? `-${truncateOffsetY}em` : undefined;

    return css`
        margin-bottom: ${marginBottom};
        padding-bottom: ${truncateOffsetY}em;
    `;
}

function gradient(gradient: string, fallbackColor = 'white', fullWidth = false) {
    // Text needs to be `inline`, or else its "clip box"
    // will span the full width of its container.
    const displayValue = fullWidth ? 'block' : 'inline flex';

    return css`
        display: ${displayValue};
        color: ${fallbackColor};
        background-size: cover;
        background-repeat: repeat;
        background-image: ${gradient};

        // The repo is not configured to "auto prefix",
        // so we have to include vendor prefixes for now.
        -webkit-box-decoration-break: clone;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        -moz-box-decoration: clone;
        -moz-background-clip: text;
        -moz-text-fill-color: transparent;

        box-decoration-break: clone;
        background-clip: text;
        text-fill-color: transparent;
    `;
}

function verticalText(bottomToTop = false) {
    return bottomToTop
        ? css`
              writing-mode: vertical-lr;
              transform: rotate(180deg);
          `
        : css`
              writing-mode: vertical-rl;
          `;
}

export const styledTypography = {
    allianceFontStack,
    tuskerFontStack,
    allianceBase,
    tuskerBase,
    breakLongLines,
    breakTextarea,
    lineClamp,
    textBoxTrim,
    truncate,
    truncateHeightFix,
    gradient,
    verticalText,
};
